/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UnitModalUpdateMutationVariables = {|
  id: string,
  code?: ?string,
  description?: ?string,
|};
export type UnitModalUpdateMutationResponse = {|
  +unitMeasureUpdate: ?{|
    +unitMeasure: ?{|
      +id: string,
      +code: string,
      +description: string,
    |}
  |}
|};
export type UnitModalUpdateMutation = {|
  variables: UnitModalUpdateMutationVariables,
  response: UnitModalUpdateMutationResponse,
|};
*/


/*
mutation UnitModalUpdateMutation(
  $id: ID!
  $code: String
  $description: String
) {
  unitMeasureUpdate(input: {id: $id, code: $code, description: $description}) {
    unitMeasure {
      id
      code
      description
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "code",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "description",
    "type": "String"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "code",
            "variableName": "code"
          },
          {
            "kind": "Variable",
            "name": "description",
            "variableName": "description"
          },
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "UnitMeasureUpdatePayload",
    "kind": "LinkedField",
    "name": "unitMeasureUpdate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UnitMeasureNode",
        "kind": "LinkedField",
        "name": "unitMeasure",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UnitModalUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UnitModalUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "UnitModalUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation UnitModalUpdateMutation(\n  $id: ID!\n  $code: String\n  $description: String\n) {\n  unitMeasureUpdate(input: {id: $id, code: $code, description: $description}) {\n    unitMeasure {\n      id\n      code\n      description\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '6608ed89da475f0b2e4ad9d797a80908';

module.exports = node;
